<template>
    <form class="test-form">
        <div
                v-if="!$auth.check()"
                class="form-group"
                :class="{error: $v.form.email.$error}"
        >
            <label>
                {{$t('labels.email')}}
            </label>
            <div class="input-group">
                <input
                        type="text"
                        required="required"
                        :placeholder="$t('placeholder.email')"
                        class="form-control"
                        v-model="form.email"
                        @input="$v.form.email.$touch"
                />
            </div>
            <template v-if="$v.form.email.$error">
                <p
                        class="error-message"
                        v-if="!$v.form.email.required"
                >
                    {{$t('validations.required', {field: $t('fields.email')})}}
                </p>
            </template>
        </div>

        <button type="button" class="btn submit" @click="submitHandler">
            {{$t('subscription.buttons.start_membership')}}
        </button>

        <div class="result-message" v-if="resultMessage">
            <p>
                {{resultMessage}}
            </p>
        </div>
    </form>
</template>
<script>
    import Spinner from "./Spinner";
    import { required, requiredIf, email } from 'vuelidate/lib/validators';

    export default {
        components: {
            Spinner,
        },
        props: {
            purchaseOption: {
                type: Object,
                required: false,
            },
            resultMessage: {
                required: true,
            },
        },
        data(){
            return {
                form: {
                    email: '',
                },
            }
        },
        validations(){
            return {
                form: {
                    email: {
                        requiredIf: requiredIf(function(){
                            //Si no esta logueado tiene que completar el email
                            return !this.$auth.check();
                        }),
                        email,
                    },
                }
            }
        },
        methods: {
            submitHandler(){
                this.$emit('submit', this.form);
            },
        },
        computed: {

        }
    }
</script>
<style scoped lang="scss">
    @import './../styles/variables';
    @import './../styles/classes';

    .test-form{
        text-align: center;
    }

    form{
        margin: 30px;
        padding: 30px;
        box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
        min-width: 250px;
    }

    .result-message{
        text-align: center;
    }

    .btn.submit{
        @extend %fresh-btn;
        font-size: 2em;
    }
</style>